export const TicketTypeAvailabilityStatus = Object.freeze({
  AVAILABLE: 'available',
  SOLD_OUT: 'sold_out',
  UNAVAILABLE: 'unavailable',
});

export const TicketTypeAvailabilityBehavior = Object.freeze({
  ALWAYS_AVAILABLE: 'always_available',
  DATE_TIME_BASED: 'date_time_based',
  AFTER_TICKET_SALE_ENDS: 'after_ticket_sale_ends',
  AFTER_TICKET_SOLD_OUT: 'after_ticket_sold_out',
  AFTER_TICKET_ENDS_OR_SOLD_OUT: 'after_ticket_ends_or_sold_out',
  UNTIL_EVENT_STARTS: 'until_event_starts',
});

export const TicketGroupAvailabilityStatus = Object.freeze({
  AVAILABLE: 'available',
  SOLD_OUT: 'sold_out',
  UNAVAILABLE: 'unavailable',
});

export const TicketGroupAvailabilityBehavior = Object.freeze({
  ALWAYS_AVAILABLE: 'always_available',
  DATE_TIME_BASED: 'date_time_based',
  AFTER_TICKET_SALE_ENDS: 'after_ticket_sale_ends',
  AFTER_TICKET_SOLD_OUT: 'after_ticket_sold_out',
  AFTER_TICKET_ENDS_OR_SOLD_OUT: 'after_ticket_ends_or_sold_out',
  UNTIL_EVENT_STARTS: 'until_event_starts',
});
